import { render, staticRenderFns } from "./CampaignStatsOverallChartLegend.vue?vue&type=template&id=52ba1c2c"
import script from "./CampaignStatsOverallChartLegend.vue?vue&type=script&lang=js"
export * from "./CampaignStatsOverallChartLegend.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatsOverallChartLegend.vue?vue&type=style&index=0&id=52ba1c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports